import React from 'react';
import classNames from 'classnames';
import BoringAvatar from 'boring-avatars';
import { CSSTransition, SwitchTransition } from 'react-transition-group';

export default function Avatar({
  url,
  size = null,
  initials = null,
  placeholder = null,
  name = null,
  square = false,
  bgGlow = false,
  ...props
}) {
  const { grayscale, ...additionalProps } = props;
  additionalProps.className = classNames(
    'avatar',
    props.className,
    size && `avatar-${size}`,
    grayscale && 'grayscale',
  );

  let img = <span {...additionalProps} style={{ backgroundImage: `url(${url})` }} />;

  if (!url) {
    img = (
      <span {...additionalProps}>
        <SwitchTransition mode="in-out">
          <CSSTransition
            key={name}
            // this is due to an issue with the types, but below follows documentation
            // @ts-ignore
            addEndListener={(node, done) => node.addEventListener('transitionend', done, false)}
            classNames="fade"
          >
            <span className="avatar-placeholder">
              <BoringAvatar
                size={10}
                square={square}
                name={name || ''}
                variant="marble"
                colors={[
                  'rgba(74,144,226,0.8)',
                  'rgba(76,198,215,0.8)',
                  'rgba(201,135,229,0.8)',
                  'rgba(74,144,226,0.8)',
                  'rgba(255,183,74,0.8)',
                  'rgba(143,198,96,0.8)',
                ]}
              />
              {!initials ? null : <span className="avatar-placeholder-text">{initials}</span>}
            </span>
          </CSSTransition>
        </SwitchTransition>
      </span>
    );
  }

  if (!bgGlow) {
    return img;
  } else {
    let blurImg = null;

    if (!url) {
      blurImg = img;
    }

    return (
      <div className="avatar-container">
        <span
          className={classNames('avatar-blur', size)}
          style={url ? { backgroundImage: `url(${url})` } : {}}
        >
          {blurImg}
        </span>
        {img}
      </div>
    );
  }
}
